import SessionService from './SessionService';

const API_ENDPOINT = `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/ai/analytics/track/event`;
const API_ENDPOINT_FEATURES = `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/ai/features/log-event`;

/**
 * Logs a feature or page event to the backend.
 * @param {object} eventData - The data for the event.
 * @param {string} eventData.page_url - The URL of the page where the event occurred.
 * @param {string} eventData.page_name - A human-readable name for the page/feature.
 * @param {string} eventData.event_type - The type of event (e.g., 'page_view', 'action_taken').
 * @param {number} [eventData.time_spent_seconds] - Time spent on the page in seconds.
 * @param {boolean} [eventData.completed] - If a specific goal on the page was completed.
 * @param {boolean} [eventData.action_taken] - If a primary action was taken.
 * @param {boolean} [eventData.paywall_encountered] - If the user hit a paywall.
 */
const logEvent = async (eventData) => {
  try {
    const session_id = SessionService.getSessionId();
    let token = localStorage.getItem('authToken');

    // Extract standard fields
    const { page_url, page_name, event_type, event_name, action_taken, activity_description, ...extraFields } = eventData;

    const headers = {
      'Content-Type': 'application/json'
    };

    if (token) {
      // Remove any extra quotes that might be around the token
      token = token.replace(/^"(.*)"$/, '$1');
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        session_id,
        page_url,
        page_name,
        event_type,
        event_name: page_name || event_name || 'unknown',
        action_taken,
        activity_description,
        properties: extraFields // Wrap extra fields in properties object
      })
    });

    if (!response.ok) {
      console.error('Failed to log event. Status:', response.status);
    }
  } catch (error) {
    console.error('Error logging event:', error);
  }
};

const logEventFeatures = async (eventData) => {
  try {
    const session_id = SessionService.getSessionId();
    let token = localStorage.getItem('authToken');

    const headers = {
      'Content-Type': 'application/json'
    };

    if (token) {
      // Remove any extra quotes that might be around the token
      token = token.replace(/^"(.*)"$/, '$1');
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(API_ENDPOINT_FEATURES, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        ...eventData,
        session_id
      })
    });
    console.log(response);
  } catch (error) {
    console.error('Failed to log event:', error);
  }
};
const TrackingService = {
  logEvent,
  logEventFeatures
};

export default TrackingService;
